import React, { useState, useEffect } from "react";

export const toolbarStyles: {
  desktop: { container: React.CSSProperties; closingButtonWrapper: React.CSSProperties; iconsWrapper: React.CSSProperties },
  mobile: { container: React.CSSProperties; closingButtonWrapper: React.CSSProperties; iconsWrapper: React.CSSProperties }
} = {
  mobile: {
    container: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      gap: "0.5rem",
      width: "100%",
      margin: "0",
    },
    closingButtonWrapper: {
      display: "flex",
      justifyContent: "flex-end",
      width: "100%",
      paddingRight: "1rem",
      height: "30px"
    },
    iconsWrapper: {
      overflow: "scroll",
      overflowX: "hidden",
      display: "flex",
      flexDirection: "row",
      justifyContent: "center",
      gap: "0.5rem",
      width: "100%",
    },
  },

  desktop: {
    container: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      gap: "1rem",
      margin: "0 auto",
    },
    closingButtonWrapper: {
      display: "flex",
      justifyContent: "center",
      width: "100%",
    },
    iconsWrapper: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      gap: "1.5rem",
      width: "100%",
      maxHeight: "80vh",
      overflowY: "auto",
      paddingLeft: "1rem",
      paddingTop: "1rem",
      direction: "rtl"
    },
  },
};

export function isDesktop() {
  const [isDesktop, setIsDesktop] = useState(window.innerWidth >= 768);

  useEffect(() => {
    const handleResize = () => {
      setIsDesktop(window.innerWidth >= 768);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return isDesktop;
}

